if (!window.npxPhenibutGalleryBound) {
  window.npxPhenibutGalleryBound = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-restock-view]');
    if (!button) return;
    const gallery = button.closest('[data-restock-gallery]');
    if (!gallery) return;
    const view = button.dataset.restockView;
    gallery.querySelectorAll('[data-restock-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.restockPanel !== view;
    });
    gallery.querySelectorAll('[data-restock-view]').forEach((control) => {
      control.setAttribute('aria-pressed', String(control === button));
    });
  });
}

// The native variant component replaces query parameters on every request.
// Preserve this alternate view without changing its cart or variant logic.
function npxBindPhenibutVariantView() {
  document.querySelectorAll('.npx-phenibut-pdp xo-product-variants').forEach((variants) => {
    if (variants.npxRestockViewBound || typeof variants.getUrl !== 'function') return;
    variants.npxRestockViewBound = true;
    const nativeGetUrl = variants.getUrl.bind(variants);
    variants.getUrl = (...args) => {
      const url = new URL(nativeGetUrl(...args), window.location.origin);
      url.searchParams.set('view', 'phenibut-500mg');
      return url.href;
    };
    if (typeof variants.handleProductInformation === 'function') {
      const nativeInformation = variants.handleProductInformation.bind(variants);
      variants.handleProductInformation = (...args) => {
        const before = new URL(window.location.href);
        nativeInformation(...args);
        const after = new URL(window.location.href);
        if (after.pathname !== before.pathname) return;
        after.searchParams.set('view', 'phenibut-500mg');
        before.searchParams.forEach((value, key) => {
          if (key.startsWith('utm_') && !after.searchParams.has(key)) after.searchParams.set(key, value);
        });
        window.history.replaceState(window.history.state, '', after.href);
      };
    }
  });
}
if ('customElements' in window) {
  customElements.whenDefined('xo-product-variants').then(npxBindPhenibutVariantView);
}
document.addEventListener('shopify:section:load', npxBindPhenibutVariantView);
